import types from './types';

function internationalOperationsReducer(state, action) {
  switch(action.type) {
    case types.SET_COIN:
      return {...state, operations: {...state.operations, monedaExtranjera: action.monedaExtranjera}}
    case types.SET_PRODUCTS_COIN:
      return {...state, operations: {...state.operations, productMonedaExtranjera: action.productMonedaExtranjera}}
    case types.SET_TRANSATION_TYPE:
      return {...state, operations: {...state.operations, transationType: action.transationType}}
    case types.SET_OPERATIONS:
      return {...state, operations: action.operations}
    case types.SET_PUBLIC_STAFF:
      return {...state, politicallyExposedPerson: {...state.politicallyExposedPerson, publicStaff: action.publicStaff}}
    case types.SET_MANAGE_PUBLIC_RESOURCES:
      return {...state, politicallyExposedPerson: {...state.politicallyExposedPerson, managePublicResources: action.managePublicResources}}
    case types.SET_POLITICALLY_EXPOSED:
      return {...state, politicallyExposedPerson: {...state.politicallyExposedPerson, politicallyExposed: action.politicallyExposed}}
    case types.SET_POLITICALLY_EXPOSED_RELATIVES:
      return {...state, politicallyExposedPerson: {...state.politicallyExposedPerson, politicallyExposedRelatives: action.politicallyExposedRelatives}}
    case types.SET_POLITICALLY_EXPOSED_PERSON:
      return {...state, politicallyExposedPerson: action.politicallyExposedPerson}
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation}
    case types.SET_CREDIT:
      return {...state, credit: action.credit}
    case types.SET_RELATIVES:
      return {...state, relatives: action.relatives}
    default:
      return state;
  }
}

export default internationalOperationsReducer;
